export default __webpack_public_path__ + "static/media/Vector-3.05d878fc.svg";